import { defineMessages } from 'react-intl';

export default defineMessages({
  scheduleText: {
    id: 'app.shopDetails.pages.shopInfo.components.ScheduleShifts.text',
    defaultMessage: '{from} a {to} hs',
  },
});
